<div class="media-container">
  @switch (type) {
    @case('image'){
      <img dalDefaultImg [src]="imageUrl" alt="Image"
        [ngClass]="customClass ? customClass : (applyClass ? 'image g-image-height' : '')" />
    }
    @case('audio'){
      <div class="audio-container">
        <img src="/assets/rendition.jpeg" alt="Audio Thumbnail" class="audio-thumbnail" />
        <audio #audioPlayer controls class="audio-player">
          <source [src]="safeUrl" type="audio/mp3" />
          Your browser does not support the audio tag.
        </audio>
      </div>
    }
    @case('video'){
      <video #videoPlayer controls>
        <source [src]="safeUrl" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    }
    @case('application'){
      <img dalDefaultImg [src]="imageUrl" alt="Image"
        [ngClass]="customClass ? customClass : (applyClass ? 'image g-image-height' : '')" />
    }
    @default{
      <div>Unsupported media type</div>
    }
  }
</div>
